import {searchRegistry} from "../../platform/search/register/search-registry";
import {ChartPie} from "lucide-react";

searchRegistry.register([
    {
        id: "PollVote.list",
        title: "Polls & Vote",
        description: "Create Polls",
        route: "/poll",
        category: "Administration",
        permissions: ["ADMIN","EMPLOYEE",'USER'],
        tags: ["poll",'vote','polls','votes'],
        icon: ChartPie,
        type: 'quickLink'
    }
]);
